import styled, { css } from 'styled-components';

import ShowMoreText from '@libs/react-show-more-text';

export const Container = styled.div`
  display: grid;
  gap: 20px;
  width: 100%;

  border-radius: 2px;
  color: ${({ theme }) => theme.palette.grey1100};

  position: relative;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 20px 0;
    padding: 23px 16px 21px 16px;
  }

  & > .hotelDetail__featuresTitle {
    margin-bottom: 20px;
  }
`;

export const CustomShowMoreText = styled(ShowMoreText)`
  font-size: 14px;
  color: ${(p) => p.theme.palette.darkGrey};
  line-height: 1.67;
  white-space: initial;
`;

export const ShowMoreLink = styled.span`
  text-decoration: underline;
  font-weight: 700;
`;

export const FeatureGroupDescription = styled.div`
  color: ${(p) => p.theme.palette.darkGrey};
  font-weight: 400;
  white-space: initial;
`;

export const FeatureListContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 10px 20px;
  margin-top: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: auto;
  }
`;

export const Feature = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;
export const TitleCondition = styled.div`
  margin-bottom: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 16px;
  }
`;
export const BodyContainer = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
`;
export const ConditionWrapper = styled.div`
  margin-top: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 6px;
  }
`;
export const NonFreeWrapper = styled.div`
  width: 100%;
  text-align: right;
`;
export const SessionNameWrapper = styled.div`
  height: 52px;
  width: 100%;
`;
export const TabsContainer = styled.div<{
  hasCyprus?: boolean;
}>`
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    ${({ hasCyprus }) =>
      hasCyprus
        ? css`
            &&& div {
              display: grid;
              grid-template-columns: 100px 1fr 100px 100px 100px;
            }
          `
        : ''}
  }
`;

export const TabWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledTab = styled.button<{
  selected?: boolean;
  disabled?: boolean;
  control?: boolean;
}>`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  width: unset;
  min-width: unset;
  flex: 1;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  padding: 20px 0;
  justify-content: center;
  height: 52px;
  border: none;

  ${(p) =>
    p.selected
      ? css`
          background-color: ${({ theme }) => theme.palette.primaryBrand};
          font-size: 18px;
          font-weight: 700;
        `
      : null}
`;

export const TabText = styled.span<{ isSelected?: boolean }>`
  padding-left: 5px;
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.palette.white : theme.palette.eclipse};
`;

export const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
